export default __webpack_public_path__ + "static/media/fashion-styling.inline.105d0015.svg";